import { Select, styled } from "@mui/material";
import { BaseInputPropsType } from "../../../types/app.type";

export const BaseSelect = styled(Select)<BaseInputPropsType>(({ colour, bgcolor, fontWeight }) => {
    return {
        fontFamily: "Inter",
        fontWeight: fontWeight || 500,
        fontSize: "16px",
        lineHeight: "normal",
        border: "1px solid #C0C0C0",
        borderRadius: "5px",
        color: colour || "#373737",
        backgroundColor: bgcolor || "transparent",
        padding: "calc(var(--basic-padding)/2)",
        outline: "none",
        "& .MuiInputBase-input": {
            textOverflow: "ellipsis",
            padding: 0,
        },
        "& fieldset": {
            border: "1px solid #C0C0C0 !important",
        }
    }
})